module.exports = __webpack_public_path__ + "img/animation2.30663994.png";